import React, {useCallback, useState} from "react";
import classes from "./styles.module.css";

function fmt(kopecks) {
    if (!kopecks) return "0";
    var rub = kopecks / 100;
    if (rub >= 1000000) return (rub / 1000000).toFixed(1) + "M";
    if (rub >= 1000) return Math.round(rub / 1000) + "K";
    return Math.round(rub).toLocaleString("ru-RU");
}

function fmtC(n) {
    if (!n) return "0";
    if (n >= 1000) return (n / 1000).toFixed(1) + "K";
    return String(n);
}

function T(props) {
    if (props.v === "up") return React.createElement("span", {className: classes.Up}, "\u2191");
    if (props.v === "down") return React.createElement("span", {className: classes.Dn}, "\u2193");
    return null;
}

function Cell(props) {
    return (
        <td className={props.cls}>
            <span>{props.sum}</span>
            {props.trend && React.createElement(T, {v: props.trend})}
            <span className={classes.Sep}>{"/"}</span>
            <span className={classes.Cnt}>{props.cnt}</span>
        </td>
    );
}

// Combine payments+payouts into success/decline totals
function combine(merchant, status) {
    var pay = merchant.payments && merchant.payments[status];
    var out = merchant.payouts && merchant.payouts[status];
    var result = {};
    var periods = ["24h", "7d", "30d"];
    for (var i = 0; i < periods.length; i++) {
        var p = periods[i];
        var pa = pay && pay[p] ? pay[p] : {amount: 0, count: 0};
        var oa = out && out[p] ? out[p] : {amount: 0, count: 0};
        result[p] = {
            amount: (pa.amount || 0) + (oa.amount || 0),
            count: (pa.count || 0) + (oa.count || 0),
            trend_amount: pa.trend_amount || oa.trend_amount || "same",
            trend_count: pa.trend_count || oa.trend_count || "same",
        };
    }
    return result;
}

function combinePrev(merchant, status) {
    var prev = merchant.previous;
    if (!prev) return null;
    var pay = prev.payments && prev.payments[status];
    var out = prev.payouts && prev.payouts[status];
    var result = {};
    var periods = ["24h", "7d", "30d"];
    for (var i = 0; i < periods.length; i++) {
        var p = periods[i];
        var pa = pay && pay[p] ? pay[p] : {amount: 0, count: 0};
        var oa = out && out[p] ? out[p] : {amount: 0, count: 0};
        result[p] = {
            amount: (pa.amount || 0) + (oa.amount || 0),
            count: (pa.count || 0) + (oa.count || 0),
        };
    }
    return result;
}

function hasTraffic(m) {
    var s = combine(m, "success");
    var d = combine(m, "decline");
    return s["24h"].amount > 0 || s["24h"].count > 0 || s["7d"].amount > 0 || s["7d"].count > 0
        || s["30d"].amount > 0 || s["30d"].count > 0
        || d["24h"].count > 0 || d["7d"].count > 0 || d["30d"].count > 0;
}

function exportCSV(merchants) {
    var rows = [["Merchant", "Type", "24h Sum", "24h Count", "7d Sum", "7d Count", "30d Sum", "30d Count"]];
    merchants.forEach(function(m) {
        ["success", "decline"].forEach(function(st) {
            var c = combine(m, st);
            rows.push([m.name, st, c["24h"].amount/100, c["24h"].count, c["7d"].amount/100, c["7d"].count, c["30d"].amount/100, c["30d"].count]);
        });
    });
    var csv = rows.map(function(r) { return r.join(";"); }).join("\n");
    var blob = new Blob(["\uFEFF" + csv], {type: "text/csv;charset=utf-8;"});
    var url = URL.createObjectURL(blob);
    var a = document.createElement("a");
    a.href = url;
    a.setAttribute("download", "traffic_" + new Date().toISOString().slice(0,10) + ".csv");
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(url);
}

function MerchantBlock(props) {
    var m = props.merchant;
    var idx = props.index;
    var isOdd = idx % 2 === 1;
    var suc = combine(m, "success");
    var dec = combine(m, "decline");
    var prevSuc = combinePrev(m, "success");
    var prevDec = combinePrev(m, "decline");
    var bg = isOdd ? classes.Odd : "";

    return (
        <React.Fragment>
            <tr className={bg}>
                <td className={classes.Name} rowSpan={2}>{m.name}</td>
                <td className={classes.BarOk}/>
                <Cell cls={classes.Val} sum={fmt(suc["24h"].amount)} cnt={fmtC(suc["24h"].count)} trend={suc["24h"].trend_amount}/>
                <Cell cls={classes.Val} sum={fmt(suc["7d"].amount)} cnt={fmtC(suc["7d"].count)} trend={suc["7d"].trend_amount}/>
                <Cell cls={classes.Val30} sum={fmt(suc["30d"].amount)} cnt={fmtC(suc["30d"].count)}/>
                <td className={classes.PDiv} rowSpan={2}/>
                <Cell cls={classes.PVal} sum={prevSuc ? fmt(prevSuc["24h"].amount) : "0"} cnt={prevSuc ? fmtC(prevSuc["24h"].count) : "0"}/>
                <Cell cls={classes.PVal} sum={prevSuc ? fmt(prevSuc["7d"].amount) : "0"} cnt={prevSuc ? fmtC(prevSuc["7d"].count) : "0"}/>
                <Cell cls={classes.PVal30} sum={prevSuc ? fmt(prevSuc["30d"].amount) : "0"} cnt={prevSuc ? fmtC(prevSuc["30d"].count) : "0"}/>
            </tr>
            <tr className={bg}>
                <td className={classes.BarFail}/>
                <Cell cls={classes.Val} sum={fmt(dec["24h"].amount)} cnt={fmtC(dec["24h"].count)} trend={dec["24h"].trend_amount}/>
                <Cell cls={classes.Val} sum={fmt(dec["7d"].amount)} cnt={fmtC(dec["7d"].count)} trend={dec["7d"].trend_amount}/>
                <Cell cls={classes.Val30} sum={fmt(dec["30d"].amount)} cnt={fmtC(dec["30d"].count)}/>
                <Cell cls={classes.PVal} sum={prevDec ? fmt(prevDec["24h"].amount) : "0"} cnt={prevDec ? fmtC(prevDec["24h"].count) : "0"}/>
                <Cell cls={classes.PVal} sum={prevDec ? fmt(prevDec["7d"].amount) : "0"} cnt={prevDec ? fmtC(prevDec["7d"].count) : "0"}/>
                <Cell cls={classes.PVal30} sum={prevDec ? fmt(prevDec["30d"].amount) : "0"} cnt={prevDec ? fmtC(prevDec["30d"].count) : "0"}/>
            </tr>
        </React.Fragment>
    );
}

export default function TrafficMonitoringTable(props) {
    var merchants = props.merchants || [];
    var updatedAt = props.updatedAt;
    var onRefresh = props.onRefresh;
    var loading = props.loading;

    var [isFocus, setIsFocus] = useState(false);

    var toggleFocus = useCallback(function() {
        setIsFocus(function(v) { return !v; });
    }, []);

    var updatedTime = updatedAt ? new Date(updatedAt).toLocaleTimeString("ru-RU") : "";
    var active = merchants.filter(hasTraffic);

    return (
        <div className={[classes.Wrap, isFocus ? classes.Focus : ""].join(" ")}>
            <div className={classes.Header}>
                <div className={classes.HL}>
                    <h5 className={classes.Title}>{"\u041C\u043E\u043D\u0438\u0442\u043E\u0440\u0438\u043D\u0433 \u0442\u0440\u0430\u0444\u0438\u043A\u0430"}</h5>
                    {updatedAt && (
                        <span className={classes.Upd}>{updatedTime}<span className={classes.Live}>{" \u25CF live"}</span></span>
                    )}
                </div>
                <div className={classes.HR}>
                    {onRefresh && <button className={classes.Btn} onClick={onRefresh} disabled={loading}>{"\u21BB"}</button>}
                    <button className={classes.Btn} onClick={function() { exportCSV(active); }}>{"CSV"}</button>
                    <button className={classes.Btn} onClick={toggleFocus} title={isFocus ? "\u0421\u0432\u0435\u0440\u043D\u0443\u0442\u044C" : "\u0422\u043E\u043B\u044C\u043A\u043E \u0442\u0430\u0431\u043B\u0438\u0446\u0430"}>{isFocus ? "\u2716" : "\u26F6"}</button>
                </div>
            </div>

            {loading && merchants.length === 0 && <div className={classes.Empty}>{"\u0417\u0430\u0433\u0440\u0443\u0437\u043A\u0430..."}</div>}
            {!loading && active.length === 0 && <div className={classes.Empty}>{"\u041D\u0435\u0442 \u0434\u0430\u043D\u043D\u044B\u0445"}</div>}

            {active.length > 0 && (
                <div className={classes.TW}>
                    <table className={classes.Tbl}>
                        <thead>
                            <tr>
                                <th className={classes.Th} rowSpan={2}>{"\u041C\u0435\u0440\u0447\u0430\u043D\u0442"}</th>
                                <th className={classes.ThBar} rowSpan={2}/>
                                <th className={classes.Th}>{"24\u0447"}</th>
                                <th className={classes.Th}>{"7\u0434"}</th>
                                <th className={classes.Th30}>{"30\u0434"}</th>
                                <th className={classes.ThPDiv} rowSpan={2}/>
                                <th className={classes.ThP2}>{"24\u0447"}</th>
                                <th className={classes.ThP2}>{"7\u0434"}</th>
                                <th className={classes.ThP30}>{"30\u0434"}</th>
                            </tr>
                            <tr>
                                <th className={classes.ThS}>{"\u0441\u0443\u043C / \u043A\u043E\u043B"}</th>
                                <th className={classes.ThS}>{"\u0441\u0443\u043C / \u043A\u043E\u043B"}</th>
                                <th className={classes.ThS30}>{"\u0441\u0443\u043C / \u043A\u043E\u043B"}</th>
                                <th className={classes.ThSP}>{"\u0441\u0443\u043C / \u043A\u043E\u043B"}</th>
                                <th className={classes.ThSP}>{"\u0441\u0443\u043C / \u043A\u043E\u043B"}</th>
                                <th className={classes.ThSP30}>{"\u0441\u0443\u043C / \u043A\u043E\u043B"}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {active.map(function(m, i) {
                                return React.createElement(MerchantBlock, {key: m.id, merchant: m, index: i});
                            })}
                        </tbody>
                    </table>
                </div>
            )}
        </div>
    );
}



// WEBPACK FOOTER //
// ./src/Components/ComponentsOfAdministrator/TrafficMonitoringTable/index.js